import { toString1pkumu07cwy4m as toString } from './js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function arrayOf(elements) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return elements;
}
function toString_0(_this__u8e3s4) {
  var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : toString(_this__u8e3s4);
  return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
}
function plus(_this__u8e3s4, other) {
  var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : toString(_this__u8e3s4);
  var tmp = tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  var tmp3_elvis_lhs = other == null ? null : toString(other);
  return tmp + (tmp3_elvis_lhs == null ? 'null' : tmp3_elvis_lhs);
}
//region block: exports
export {
  arrayOf as arrayOf1akklvh2at202,
  plus as plus17rl43at52ays,
  toString_0 as toString30pk9tzaqopn,
};
//endregion

//# sourceMappingURL=Library.mjs.map
